I<template>
  <div class="cell-item">
    <label v-if="$slots.title" class="title">{{ label }}</label>
    <label v-else class="title">{{ label }}</label>
    <span v-if="$slots.value" class="value"><slot name="value"></slot></span>
    <span v-else class="value">{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: "CellItem",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number, Boolean],
      default: "",
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.cell-item {
  padding: 3px 5px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  line-height: 20px;
  .title {
    display: inline-block;
    width: 1.8rem;
  }
  .value {
    color: #999999;
    display: inline-block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
  }
}
</style>
